(function ($) {

    this.init = function () {

        this.ProductCarousel();
    };

    this.ProductCarousel = function () {

        // TODO: wE need to do this for EACH of the carousels currently on the screen
        $(".productcarousel-slides").slick({
            dots: false,
            arrows: true,
            appendArrows: $(".productcarousel-controls-arrows"),
            prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous Slide" tabindex="0" role="button"><i class="fas fa-angle-left"></i></button>',
            nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next Slide" tabindex="0" role="button"><i class="fas fa-angle-right"></i></button>',
            centerMode: false,
            centerPadding: "20px",
            slidesToShow: 2,
            autoplay: false,
            infinite: false
        });
    };

    this.init();

})(jQuery);